<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert" />
      DMS进销存平衡报表—构建前需要先
      <router-link to="/report/data" slot="extra">(同步统计数据)</router-link>
    </p>
    <template slot="extra"> </template>
    <Row>
      <Col span="24">
        <Input
          v-model="query.spCode"
          placeholder="资金商code"
          class="public-inp md5"
        />
        <Select
          v-model="query.year"
          placeholder="请选择统计年份"
          class="public-inp md5"
        >
          <Option v-for="item in yearList" :value="item" :key="item"
            >{{ item }}
          </Option>
        </Select>
        <Select
          v-model="query.month"
          placeholder="请选择统计月份"
          class="public-inp md5"
        >
          <Option v-for="item in monthList" :value="item" :key="item"
            >{{ item }}
          </Option>
        </Select>
        <Button
          type="primary"
          icon="md-refresh"
          class="public-fr"
          @click="buildReport()"
          :disabled="isDisabled"
          v-access="'report.spTotal.query'"
          >构建统计报表
        </Button>
        <!--      <Button type="primary" icon="md-add" class="public-fr" @click="stockImport()">初始化期初|期末库存</Button>-->
        <Button
          class="public-fr"
          @click="reset()"
          v-access="'report.spTotal.reset'"
          >重置</Button
        >
        <Button
          class="public-fr"
          type="primary"
          icon="ios-search"
          @click="getList()"
          v-access="'report.spTotal.query'"
          >查询</Button
        >
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ row, index }" slot="sort">
            <span v-show="false">{{ row.code }}</span>
            {{ index + 1 }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <a href="javascript:;" @click="editFn(row)">编辑</a>
          </template>
          <template slot-scope="{ row }" slot="status">
            <i-switch
              :value="row.status == 1"
              :before-change="beforeStateChange"
              @on-change="stateChange(row, $event)"
            />
          </template>
        </Table>
        <Page
          :style="{ float: 'right', marginTop: '10px' }"
          :total="total"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          show-elevator
          @on-change="pageNumChange"
          @on-page-size-change="pageSizeChange"
        />
      </Col>
    </Row>
  </Card>
</template>
<script>
import columns from "@/views/task/columns";

export default {
  data() {
    return {
      visiable: false,
      open: false,
      query: {
        page: 1,
        rows: 10,
        spCode: "",
        year: "",
        month: "",
      },
      columns: [
        {
          title: "id",
          key: "id",
          width: 70,
          fixed: "left",
        },
        {
          title: "年/月",
          key: "year",
          width: 85,
          render: (h, params) => {
            let name = params.row.year + "/" + params.row.month;
            return h("div", name);
          },
        },
        {
          title: "资金商code",
          key: "spCode",
          width: 110,
        },
        {
          title: "资金商名称",
          key: "name",
          width: 160,
        },
        {
          title: "期初库存",
          key: "openingStock",
          width: 100,
        },
        {
          title: "sellIn",
          key: "dmsSellin",
          width: 80,
        },
        {
          title: "sellOut",
          key: "dmsSellout",
          width: 80,
        },
        {
          title: "其他库存",
          key: "dmsOther",
          width: 85,
        },
        {
          title: "期末库存",
          key: "endingStock",
          width: 100,
        },
        {
          title: "理论库存",
          key: "stock",
          width: 85,
        },
        {
          title: "GAP(实盘-理论)",
          key: "gap",
          width: 130,
        },
        {
          title: "创建时间",
          key: "createtime",
          width: 150,
        },
        {
          title: "更新时间",
          key: "updatetime",
          width: 150,
          fixed: "right",
        },
      ],
      tbList: [],
      loading: false,
      total: 0,
      yearList: [2020, 2021, 2022, 2023, 2024, 2025, 2026],
      monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      isDisabled: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let data = this.query;
      this.loading = true;
      this.$api.getSpReportList(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
          this.total = res.total;
        }
      });
    },
    reset() {
      this.query.spCode = "";
      this.query.year = "";
      this.query.month = "";
      this.$nextTick(() => {
        this.getList();
      });
    },
    uploadToggle() {
      this.visiable = !this.visiable;
    },
    // 页码
    pageNumChange(pageNum) {
      this.query.page = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.query.rows = pageSize;
      // 页码变动触发pageNumChange
      if (this.query.page == 1) {
        this.getList();
      } else {
        this.query.page = 1;
      }
    },
    buildReport() {
      if (this.query.year == "") {
        this.$Message.error("请选择报表年份！");
        return false;
      }

      if (this.query.month == "") {
        this.$Message.error("请选择报表月份！");
        return false;
      }

      this.isDisabled = true;
      this.$api.buildSpDataReport(this.query).then((res) => {
        if (res.code == "200") {
          this.$Message.success("构建成功");
          this.getList();
        } else {
          this.$Message.error("构建失败！");
        }

        this.isDisabled = false;
      });
    },
  },
};
</script>
<style scoped>
.md5 {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/report/spTotal.vue